// extracted by mini-css-extract-plugin
export default {"container":"Products_container__F3e+b","products":"Products_products__WLzgl","menu":"Products_menu__BbCxG","list":"Products_list__wx-LJ","product":"Products_product__crNeA"};